import React from 'react';
import { useNavigate } from 'react-router-dom';

const TopBar = () => {
  const navigate = useNavigate();

  return (
    <div className="text-white py-1" style={{ backgroundColor: '#CFA047' }}>
      <div className="container">
        <style>{`
          .topbar-text { font-size: 9px; }
          @media (min-width: 576px) { .topbar-text { font-size: 12px; } }
          @media (min-width: 768px) { .topbar-text { font-size: 14px; } }
          .topbar-link {
            color: white;
            font-weight: 700;
            text-decoration: underline;
            text-underline-offset: 2px;
            background: none;
            border: none;
            cursor: pointer;
            font-size: inherit;
            font-family: inherit;
            padding: 0;
            transition: opacity 0.18s;
          }
          .topbar-link:hover { opacity: 0.8; }
          .topbar-sep { margin: 0 6px; opacity: 0.55; }
        `}</style>
        <div className="d-flex justify-content-between align-items-center topbar-text text-nowrap">
          <div className="d-flex gap-2 gap-md-4">
            <span className="d-flex align-items-center gap-1 gap-md-2">
              <i className="fa-solid fa-phone"></i> +91 8608680756
            </span>
            <span className="d-flex align-items-center gap-1 gap-md-2">
              <i className="fa-solid fa-envelope"></i> help@legalinfos.in
            </span>
          </div>
          <div className="d-flex align-items-center">
            <button
              id="topbar-register-btn"
              className="topbar-link"
              onClick={() => navigate('/')}
            >
              Register
            </button>
            <span className="topbar-sep">|</span>
            <button
              id="topbar-login-btn"
              className="topbar-link"
              onClick={() => navigate('/')}
            >
              Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
